import React from "react"
import { useTranslation } from "react-i18next"

function ProviderSummaryNotEnabledPage() {
    const [t] = useTranslation()
    return (
        <div className="card shadow">
            <div className="card-body">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <div className="col text-center">
                                    <h1 className="mb-2 text-bold">{t("ProviderSummaryDisabledPage.title")}</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col text-center">
                                    <h3 className="mb-4">{t("ProviderSummaryDisabledPage.explaination")}</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col card">
                                    <div className="card-body">
                                        <i className="fas fa-search fa-5x my-2 text-blue" />
                                        <h3>{t("ProviderSummaryDisabledPage.search")}</h3>
                                        <p className="lead">{t("ProviderSummaryDisabledPage.search_info")}</p>
                                    </div>
                                </div>
                                <div className="col card mx-4">
                                    <div className="card-body">
                                        <i className="fas fa-chart-line fa-5x my-2 text-green" />
                                        <h3>{t("ProviderSummaryDisabledPage.price_leader")}</h3>
                                        <p className="lead">{t("ProviderSummaryDisabledPage.price_leader_info")}</p>
                                    </div>
                                </div>
                                <div className="col card">
                                    <div className="card-body">
                                        <i className="fas fa-rocket fa-5x my-2 text-red" />
                                        <h3>{t("ProviderSummaryDisabledPage.market_overview")}</h3>
                                        <p className="lead">{t("ProviderSummaryDisabledPage.market_overview_info")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row card my-4">
                                <div className="col card-body">
                                    <h4>{t("ProviderSummaryDisabledPage.contact_text")}</h4>
                                    <a
                                        className="btn btn-primary btn-lg mt-4"
                                        href="mailto:info@sylphen.com?subject=Händleranalyse"
                                    >
                                        {t("ProviderSummaryDisabledPage.contact")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProviderSummaryNotEnabledPage
